<div class="mb-3">
  @if (!expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(true)">
      <mat-icon class="icon">chevron_right</mat-icon>
      <strong>Expand for Encounter Eligibility Details</strong>
    </div>
  }

  @if (expanded) {
    <div class="expand-collapse" (click)="onExpandOrCollapseClick(false)">
      <mat-icon class="icon">expand_more</mat-icon>
      <strong>Encounter Eligibility Details</strong>
    </div>
    <div class="content">
      <p>
        If an encounter type is marked as eligible, then encounters for this type will be used to satisfy patient care ownership.
      </p>
      <p>
        If an encounter type is <em>NEW</em> or marked ineligible, encounters for this type will not be used to satisfy patient care ownership.
      </p>
    </div>
  }
</div>

